








import { defineComponent } from "@vue/composition-api";

export default defineComponent({
    name: "floorplanLegend",
    setup(props, ctx) {
        const legend = [
            {
                color: "success",
                label: "Available",
            },
            {
                color: "warning",
                label: "Partially available",
            },
            {
                color: "info",
                label: "Checked in",
            },
            {
                color: "error",
                label: "Reserved",
            },
            {
                color: "grey lighten-2",
                label: "Unavailable",
            },
        ];

        return { legend };
    },
});
